import { Type } from 'utils/types';
import { Country } from 'pages/dentist/PostJobPage/PostJob.utils';

export interface PostShiftSuccessCopyInput {
  role: Type | number;
  hasAvailableInstabookTalent: boolean;
  locationCountry?: number;
  locationEmail?: string;
}

export interface PostShiftSuccessCopy {
  title: string;
  description: string;
}

export function getShiftRoleLabelForPostSuccess(role: Type | number): string {
  switch (Number(role)) {
    case Type.Assistant:
      return 'Dental Assistant';
    case Type.Hygienist:
      return 'Dental Hygienist';
    case Type.Admin:
      return 'Reception/Admin';
    default:
      return 'Dental Professional';
  }
}

/**
 * Post-submit success modal copy shared by ShiftIsLiveModal and FindATempPageV2.
 * Instabook branch matches ShiftIsLiveModal wording (T2-6431).
 */
export function getPostShiftSuccessCopy(input: PostShiftSuccessCopyInput): PostShiftSuccessCopy {
  const roleString = getShiftRoleLabelForPostSuccess(input.role);
  const isCanada = Number(input.locationCountry) === Country.Canada;

  if (input.hasAvailableInstabookTalent) {
    return {
      title: `Insta-Book a ${roleString}`,
      description:
        `Your shift was successfully posted to all available ${roleString}s in your area.\n\n` +
        `And great news! There are ${roleString}s who indicated they are available for your shift that you can book right now without waiting.\n` +
        `We'll take you to that list now so you can browse their profiles. If you see one you want to book right now, you can do that!`,
    };
  }

  const radiusLabel = isCanada ? '110km' : '70mi';
  const emailSuffix = input.locationEmail
    ? `So keep an eye on your inbox (${input.locationEmail}) for offers from great matches.\n\n`
    : 'Keep an eye on your inbox and notifications for incoming offers!\n\n';

  return {
    title: 'Nicely done – your temping shift has been posted!',
    description:
      `We're alerting every ${roleString} within ${radiusLabel} of your office about your shift.\n\n` +
      emailSuffix +
      `If you need to edit the shift details, just tap on the date in your home calendar screen.`,
  };
}
